import { gql } from "@apollo/client";

import { TENANT_EXPORT_CONFIG_FIELDS } from "./fragments";

export const LIST_TENANT_EXPORT_CONFIGS = gql`
  ${TENANT_EXPORT_CONFIG_FIELDS}
  query listTenantExportConfigs {
    listTenantExportConfigs {
      ...TenantExportConfigFields
    }
  }
`;

export const GET_DATA_DICTIONARY = gql`
  query getDataDictionary {
    getDataDictionary {
      tables {
        name
        description
        deprecated
        columns {
          name
          description
          dataType
          nullable
          deprecated
        }
      }
    }
  }
`;

export const CREATE_S3_TENANT_EXPORT_CONFIG = gql`
  ${TENANT_EXPORT_CONFIG_FIELDS}
  mutation tenantExportConfigCreateS3(
    $name: String!
    $settings: TenantExportS3SettingsCreateInput!
  ) {
    tenantExportConfigCreateS3(name: $name, settings: $settings) {
      ...TenantExportConfigFields
    }
  }
`;

export const UPDATE_S3_TENANT_EXPORT_CONFIG = gql`
  ${TENANT_EXPORT_CONFIG_FIELDS}
  mutation tenantExportConfigUpdateS3(
    $id: ID!
    $name: String!
    $settings: TenantExportS3SettingsUpdateInput!
  ) {
    tenantExportConfigUpdateS3(id: $id, name: $name, settings: $settings) {
      ...TenantExportConfigFields
    }
  }
`;

export const CREATE_BIGQUERY_TENANT_EXPORT_CONFIG = gql`
  ${TENANT_EXPORT_CONFIG_FIELDS}
  mutation tenantExportConfigCreateBigQuery(
    $name: String!
    $settings: TenantExportBigQuerySettingsCreateInput!
  ) {
    tenantExportConfigCreateBigQuery(name: $name, settings: $settings) {
      ...TenantExportConfigFields
    }
  }
`;

export const UPDATE_BIGQUERY_TENANT_EXPORT_CONFIG = gql`
  ${TENANT_EXPORT_CONFIG_FIELDS}
  mutation tenantExportConfigUpdateBigQuery(
    $id: ID!
    $name: String!
    $settings: TenantExportBigQuerySettingsUpdateInput!
  ) {
    tenantExportConfigUpdateBigQuery(
      id: $id
      name: $name
      settings: $settings
    ) {
      ...TenantExportConfigFields
    }
  }
`;

export const DELETE_TENANT_EXPORT_CONFIG = gql`
  ${TENANT_EXPORT_CONFIG_FIELDS}
  mutation tenantExportConfigDelete($id: ID!) {
    tenantExportConfigDelete(id: $id) {
      ...TenantExportConfigFields
    }
  }
`;
